 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLE_PAGE from '@/components/title_page'
 import DED01 from '@/components/ded01'
 import EXTRA from '@/components/extra'
 import CONTENTS from '@/components/contents'
 import PROLOGUE from '@/components/prologue'
 import CH01 from '@/components/ch01'
 import CH02 from '@/components/ch02'
 import CH03 from '@/components/ch03'
 import CH04 from '@/components/ch04'
 import CH05 from '@/components/ch05'
 import CH06 from '@/components/ch06'
 import CH07 from '@/components/ch07'
 import CH08 from '@/components/ch08'
 import CH09 from '@/components/ch09'
 import CH10 from '@/components/ch10'
 import CH11 from '@/components/ch11'
 import CH12 from '@/components/ch12'
 import CH13 from '@/components/ch13'
 import CH14 from '@/components/ch14'
 import CH15 from '@/components/ch15'
 import CH16 from '@/components/ch16'
 import LOVE_2 from '@/components/love_2'
 import ACK01 from '@/components/ack01'
 import NOTES01 from '@/components/notes01'
 import CREDIT from '@/components/credit'
 import ABTATHOR from '@/components/abtathor'
 import PRAISE01 from '@/components/praise01'
 import COPY from '@/components/copy'
 import ATP01 from '@/components/atp01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/prologue",
 			"name" : "prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/ch01",
 			"name" : "ch01",
 			"component" : CH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js